import { useSearchParams } from 'react-router-dom';

export function useToken(): string {
  const [searchParams] = useSearchParams();
  return searchParams.get('token')!;
}
